import {
  GET_USER_DATA,
  SET_USER_DATA,
  SET_LOGO,
  SET_USAGE,
  SET_ORGANIZATION,
  SET_TOLLFREE_NUMBER,
  SET_TOLLFREE_NUMBER_STATUS,
  SET_TOLLFREE_NUMBER_PURCHASED,
  SET_CARD_EXPIRED,
} from "./AppUserDataTypes";

const getUserData = () => {
  return {
    type: GET_USER_DATA,
  };
};

const setUserData = (data) => {
  return {
    type: SET_USER_DATA,
    payload: data,
  };
};
export const setLogo = (data) => {
  return {
    type: SET_LOGO,
    payload: data,
  };
};
export const setUsage = (data) => {
  return {
    type: SET_USAGE,
    payload: data,
  };
};
export const setOrganization = (data) => {
  return {
    type: SET_ORGANIZATION,
    payload: data,
  };
};
export const setTollfreeNumber = (data) => {
  return {
    type: SET_TOLLFREE_NUMBER,
    payload: data,
  };
};
export const setTollfreeNumberStatus = (data) => {
  return {
    type: SET_TOLLFREE_NUMBER_STATUS,
    payload: data,
  };
};
export const setTollfreeNumberPurchased = (data) => {
  return {
    type: SET_TOLLFREE_NUMBER_PURCHASED,
    payload: data,
  };
};
export const setCardExpired = (data) => {
  return {
    type: SET_CARD_EXPIRED,
    payload: data,
  };
};
const AppUserDataAction = {
  getUserData,
  setUserData,
  setLogo,
  setUsage,
  setOrganization,
  setTollfreeNumber,
  setTollfreeNumberStatus,
  setTollfreeNumberPurchased,
  setCardExpired,
};

export default AppUserDataAction;
